import { useEffect, useState } from "react";
import SignModal from "../SignModal/SignModal";
import "./SignSearchView.css"
import Sign from "../../models/Sign";
import { useSignsByName } from "../../hooks/useALSE";
import { useDebouncedValue } from "../../hooks/useDebouncedValue";
import { debounce_ms, min_search_len } from "../../config";
import SignList from "./SignList";
import SignSearchForm from "./SignSearchFrom";

export default function SignSearchView() {
    // Sign search
    const [inputValue, setInputValue] = useState<string>('');
    const [searchName, setSearchName] = useState<string>('');
    const debouncedName = useDebouncedValue(inputValue, debounce_ms, min_search_len);
    const { data: signs, loading, error } = useSignsByName(searchName);

    useEffect(() => {
        setSearchName(debouncedName);
    }, [debouncedName]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setSearchName(inputValue);
    };


    // Sign modal
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [modalData, setModalData] = useState<Sign | null>(null);

    const handleOpenModal = (data: Sign) => {
        setModalData(data);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setModalData(null);
    };

    return (
        <div className="sign-search">
            <SignSearchForm inputValue={inputValue} handleInputChange={handleInputChange} handleFormSubmit={handleFormSubmit} />
            <SignList signs={signs} inputValue={searchName} handleOpenModal={handleOpenModal} loading={loading} error={error ? Error(error) : undefined} />
            <SignModal isOpen={isModalOpen} onClose={handleCloseModal} sign={modalData} />
        </div>
    );
}
